import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import ContactHero from './components/ContactHero';
import ContactMethods from './components/ContactMethods';
import ConsultationForm from './components/ConsultationForm';
import QuickAuditForm from './components/QuickAuditForm';
import LiveChatWidget from './components/LiveChatWidget';
import ContactInfo from './components/ContactInfo';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';

const ContactConsultationPage = () => {
  const [showConsultationForm, setShowConsultationForm] = useState(false);
  const [showQuickAuditForm, setShowQuickAuditForm] = useState(false);

  useEffect(() => {
    // Scroll to top on component mount
    window.scrollTo(0, 0);
  }, []);

  const handleMethodSelect = (methodId) => {
    switch (methodId) {
      case 'consultation':
        setShowConsultationForm(true);
        break;
      case 'quick-audit':
        setShowQuickAuditForm(true);
        break;
      case 'live-chat':
        // Live chat widget is always available
        break;
      case 'project-brief':
        setShowConsultationForm(true);
        break;
      default:
        break;
    }
  };

  const handleConsultationClick = () => {
    setShowConsultationForm(true);
  };

  const handleQuickAuditClick = () => {
    setShowQuickAuditForm(true);
  };

  return (
    <>
      <Helmet>
        <title>Contact & Consultation - Multiple Engagement Pathways | Singh Creations</title>
        <meta 
          name="description" 
          content="Connect with Singh Creations through multiple engagement pathways. Book free consultations, get quick digital audits, or chat with our experts. Transform your digital presence today." 
        />
        <meta 
          name="keywords" 
          content="digital consultation, free audit, contact singh creations, web development consultation, app development consultation, social media marketing consultation" 
        />
        <meta property="og:title" content="Contact & Consultation - Multiple Engagement Pathways | Singh Creations" />
        <meta 
          property="og:description" 
          content="Choose your preferred way to connect with Singh Creations. From strategic consultations to quick audits, we're here to transform your digital presence." 
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://singhcreations.com/contact-us" />
        <link rel="canonical" href="https://singhcreations.com/contact-us" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />
        
        <main>
          {/* Hero Section */}
          <ContactHero 
            onConsultationClick={handleConsultationClick}
            onQuickAuditClick={handleQuickAuditClick}
          />

          {/* Contact Methods */}
          <ContactMethods onMethodSelect={handleMethodSelect} />

          {/* Contact Information */}
          <ContactInfo />

          {/* Testimonials */}
          {/* <TestimonialsSection /> */}

          {/* FAQ Section */}
          <FAQSection />
        </main>

        {/* Live Chat Widget */}
        <LiveChatWidget />

        {/* Modal Forms */}
        <ConsultationForm 
          isVisible={showConsultationForm}
          onClose={() => setShowConsultationForm(false)}
        />
        
        <QuickAuditForm 
          isVisible={showQuickAuditForm}
          onClose={() => setShowQuickAuditForm(false)}
        />

        {/* Footer */}
        <footer className="bg-primary text-white py-12">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              {/* Company Info */}
              <div className="md:col-span-2">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-10 h-10 bg-gradient-to-br from-accent to-orange-400 rounded-lg flex items-center justify-center">
                    <svg viewBox="0 0 24 24" className="w-6 h-6 text-white" fill="currentColor">
                      <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold">Singh Creations</h3>
                    <p className="text-white/80 text-sm">Digital Atelier</p>
                  </div>
                </div>
                <p className="text-white/80 mb-4 max-w-md">
                  Transforming businesses through exceptional digital experiences. 
                  Where creativity meets technology to craft solutions that matter.
                </p>
                <p className="text-white/60 text-sm">
                  Ready to start your digital transformation? We're just a conversation away.
                </p>
              </div>

              {/* Quick Links */}
              <div>
                <h4 className="font-semibold mb-4">Quick Links</h4>
                <ul className="space-y-2 text-sm">
                  <li><a href="/home" className="text-white/80 hover:text-white brand-transition">Home</a></li>
                  <li><a href="/services" className="text-white/80 hover:text-white brand-transition">Services</a></li>
                  <li><a href="/about" className="text-white/80 hover:text-white brand-transition">About</a></li>
                  <li><a href="/contact" className="text-white/80 hover:text-white brand-transition">Contact</a></li>
                </ul>
              </div>

              {/* Contact Info */}
              <div>
                <h4 className="font-semibold mb-4">Get in Touch</h4>
                <div className="space-y-2 text-sm text-white/80">
                  <p>singhcreations23@gmail.com</p>
                  <p>+91-7982843491</p>
                  <p>Tilak Nagar, Delhi</p>
                </div>
              </div>
            </div>

            <div className="border-t border-white/20 mt-8 pt-8 text-center">
              <p className="text-white/60 text-sm">
                © {new Date()?.getFullYear()} Singh Creations. All rights reserved. 
                Crafting digital excellence since 2020.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default ContactConsultationPage;